import axios from "axios";
import { getAuthToken } from "@/lib/authStorage";

/** Éles: autoparks.hu → https://api.autoparks.hu (build .env nélkül is). */
export function productionBackendFromHost(hostname) {
  const host = String(hostname || "").toLowerCase().trim();
  if (!host || host === "localhost" || host === "127.0.0.1") return "";
  if (typeof window !== "undefined" && window.location?.protocol) {
    const proto = window.location.protocol;
    if (host.startsWith("api.")) return `${proto}//${host}`;
    const root = host.startsWith("www.") ? host.slice(4) : host;
    return `${proto}//api.${root}`;
  }
  return `https://api.${host.startsWith("www.") ? host.slice(4) : host}`;
}

/** Backend gyökér — dev: proxy; éles: env vagy api.{domain}. */
export function getBackendRoot() {
  if (typeof window !== "undefined" && process.env.NODE_ENV === "production") {
    const host = window.location.hostname.toLowerCase();
    if (host === "autoparks.hu" || host === "www.autoparks.hu") {
      return "";
    }
  }
  const raw = process.env.REACT_APP_BACKEND_URL;
  if (raw && raw !== "undefined" && String(raw).trim()) {
    const trimmed = String(raw).replace(/\/$/, "");
    if (
      process.env.NODE_ENV === "production" &&
      typeof window !== "undefined" &&
      /127\.0\.0\.1|localhost/i.test(trimmed)
    ) {
      const host = window.location?.hostname;
      if (host && host !== "localhost" && host !== "127.0.0.1") {
        return productionBackendFromHost(host);
      }
    }
    return trimmed;
  }
  if (process.env.NODE_ENV === "development") {
    return "";
  }
  if (typeof window !== "undefined" && window.location?.hostname) {
    return productionBackendFromHost(window.location.hostname);
  }
  return "";
}

export function getApiBase() {
  const root = getBackendRoot();
  return root ? `${root}/api` : "/api";
}

/** @deprecated használd getApiBase()-t híváskor */
export const API = getApiBase();

const api = axios.create({ timeout: 25_000 });

api.interceptors.request.use((config) => {
  config.baseURL = getApiBase();
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
